import { render, staticRenderFns } from "./RegistrarAsistenciaModal.vue?vue&type=template&id=c0a974ee&scoped=true"
import script from "./RegistrarAsistenciaModal.vue?vue&type=script&lang=js"
export * from "./RegistrarAsistenciaModal.vue?vue&type=script&lang=js"
import style0 from "./RegistrarAsistenciaModal.vue?vue&type=style&index=0&id=c0a974ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a974ee",
  null
  
)

export default component.exports